export default __webpack_public_path__ + "static/media/domestic.81d97aa4.svg";